//include 8
jQuery(function () {

    var dataTagName = /^(tag-data-|tagData)/i;
    var dataEventName = /^(tag-event-|tagEvent)/i;
    var dataEventData = /^(tag-evt-data-|tagEvtData)/i;

    var privateFunctions = {
        pushData(name, value) {
            if (typeof dataLayer == 'undefined' || !dataLayer)
                return;
            var pushObject = {};
            if (!!name) {
                pushObject[name] = value;
                dataLayer.push(pushObject);
            } else {
                dataLayer.push(value);
            }
        },
        pushEvent(name) {
            if (typeof dataLayer == 'undefined' || !dataLayer)
                return;
            if ($.type(name) === "string") {
                name = {
                    'event': name
                };
            }
            dataLayer.push(name);
        },
        bootstrap() {

            if (!!readCookie("ga-disable-UA-411685-51")) {
                return;
            }

            $("[data-google-tag]").each(function () {
                var $this = $(this);
                if ($this.data("tags-bootstrapped") == true)
                    return;
                //*********************************************
                var allDataAttributes = $this.data();

                var groupedTagData = {};
                var groupData = $this.is('[data-tag-group-data]');

                $.each(allDataAttributes, function (key, value) {
                    if (key.match(dataTagName)) {
                        var name = key.replace(dataTagName, "");
                        if (name == "Event") {
                            name = name.toLowerCase();
                        }
                        if (!!groupData) {
                            if (name.toLowerCase() == "event") {
                                groupedTagData["non_interaction"] = true;
                            }
                            groupedTagData[name] = value;
                        } else {
                            if (name.toLowerCase() == "event") {
                                var tagData = {};
                                tagData[name] = value;
                                tagData["non_interaction"] = true;
                                privateFunctions.pushData(null, tagData);
                            } else {
                                privateFunctions.pushData(name, value);
                            }
                        }
                    } else if (key.match(dataEventName)) {
                        var eventName = key.replace(dataEventName, "").toLowerCase();

                        var eventData = {};
                        $.each(allDataAttributes, function (key2, value2) {
                            if (key2.match(dataEventData)) {
                                var eventDataName = key2.replace(dataEventData, "").toLowerCase();
                                eventData[eventDataName] = value2;
                            }
                        });

                        eventData['event'] = value;

                        if (eventName == "click") {
                            eventName = "click touchend";
                        }

                        $this.on(eventName, function () {
                            privateFunctions.pushEvent(eventData);
                        });
                    }
                });

                if (!$.isEmptyObject(groupedTagData)) {
                    privateFunctions.pushData(null, groupedTagData);
                }
                //*********************************************
                $this.data("tags-bootstrapped", true);
            });
        }
    };

    //*******************************************************
    // mounting everything together *************************
    //*******************************************************  
    privateFunctions.bootstrap();
    setTimeout(function () {
        privateFunctions.bootstrap(); // damn hacks
    }, 500);
    //*******************************************************
    //*******************************************************

    var external = {
        data(name, value) {
            privateFunctions.pushData(name, value);
        },
        event(name, data) {
            data = data || {};
            data['event'] = name;
            privateFunctions.pushEvent(data);
        },
        update() {
            privateFunctions.bootstrap();
        }
    }
    window.pixelpoint.tagManager = external;

});